export default {
  type: "object",
  properties: {
    width: {
      type: "integer",
      description: "width of button in px",
      example: 210
    },
    height: {
      type: "integer",
      description: "height of button in px",
      example: 60
    }
  }
};
